// extracted by mini-css-extract-plugin
export default {"Error":"_Error--P7SsM","Icon":"_Icon--FTZNA","Header":"_Header--vlIhu","Description":"_Description--zk_Mt","Contact":"_Contact--shO1J"};